// extracted by mini-css-extract-plugin
module.exports = {"titleBox":"titleBox___2rV9K","playAll":"playAll___YjZub"};